import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import TranslationNS from '@/utils/Constants/TranslationNS'
import ScoringMark from '@/images/scoring_icon.svg?react'
import BurgerMenuSVG from '@/images/BurgerMenu.svg?react'
import NavSearch from './NavSearch'
import NavbarMobileMenu from './NavbarMobileMenu'
import NewDesignChip from '../DesignTransition/NewDesignChip'
import { useAuth } from '@/middlewares/auth/auth-context'
import { closeAdvancedSearch } from '@/utils/advancedSearchStore'

/**
 * Mobile navbar (< nav). Renders the compact Figma pill (brand mark · divider ·
 * collapsed search · hamburger). The hamburger opens the full-screen
 * `NavbarMobileMenu` side menu.
 */
export default function NavbarMobile({ isHome, stuck = false, menu, processInProgress, setProcessInProgess }) {
    const { t } = useTranslation(TranslationNS.NAVBAR)

    const authContext = useAuth()

    const [menuOpen, setMenuOpen] = useState(false)

    const closeMenu = () => setMenuOpen(false)

    // <Link to="/"> navigates to a bare '/', which clears the URL-driven home filters.
    const handleBrandClick = closeAdvancedSearch

    return (
        <>
            {/* Kit mobile nav: 58px bar inset 20px (page-pad under 600px). Stuck (kit body.nav-stuck):
                full width, no rounding, no side borders, content kept at the 20px inset. */}
            <div
                className={`flex items-center gap-3 w-full h-[58px] px-4 bg-white border border-(--nav-bd) rounded-[10px] box-border transition-[max-width,border-radius,box-shadow] ease-in-out duration-[180ms] motion-reduce:transition-none max-w-[calc(100%-40px)] mx-5
                    ${
                        stuck
                            ? 'max-w-none! mx-0! rounded-none! border-x-0 px-5! shadow-[0_6px_18px_rgba(14,16,23,.06)]'
                            : ''
                    }
                `}
            >
                {/* 35.76 x 27.76 = the icon lockup's own ratio (kit) */}
                <Link to="/" onClick={handleBrandClick} aria-label="Scoring.fit" className="flex-none s-focus-ring">
                    <ScoringMark className="block h-[27.76px] w-[35.76px]" />
                </Link>

                <NewDesignChip compact />

                {/* kit: the search field carries a 34px left hairline */}
                <span className="h-[34px] w-px shrink-0 bg-(--nav-bd)" />
                <NavSearch isMobile showButton={false} isLoggedIn={authContext.isLoggedIn} />

                <button
                    type="button"
                    aria-label={t('Open menu')}
                    aria-expanded={menuOpen}
                    onClick={() => setMenuOpen(true)}
                    className="ml-auto flex-none flex size-[38px] items-center justify-center bg-transparent border-0 p-0 cursor-pointer text-(--t-strong) s-focus-ring"
                >
                    {/* kit .nav-burger icon: 24px wide */}
                    <BurgerMenuSVG className="w-6 h-auto" />
                </button>
            </div>

            <NavbarMobileMenu
                open={menuOpen}
                onClose={closeMenu}
                menu={menu}
                processInProgress={processInProgress}
                setProcessInProgess={setProcessInProgess}
            />
        </>
    )
}
